import { api } from "../api";




// @returns issuer details
export const getIssuer = async (issuerAddress: string) => {

    const response = await api.get(`issuer/get/?issuerAddress=${issuerAddress}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};

// @returns badge list that created as issuer
export const getBadgesAsIssuer = async (issuerAddress: string) => {

    const response = await api.get(`badge/get/issuer/?issuerAddress=${issuerAddress}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};
// @returns badge list that owned as certificant
export const getBadgesAsCertificant = async (certificantAddress: string, statusFilter?: string) => {

    const response = await api.get(`/badge/get/certificant/?certificantAddress=${certificantAddress}${statusFilter ? `&statusFilter=${statusFilter}` : ''}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};
// @returns certificant list that badge is issued
export const getBadgeCertificant = async (issuerAddress: string, badgeTitle: string) => {


    const response = await api.get(`certificant/get/?issuerAddress=${issuerAddress}&title=${badgeTitle}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};
// @returns badge details for issuer single badge
export const getIssuerBadgeDetail = async (issuerAddress: string, badgeTitle: string) => {

    const response = await api.get(`/badge/get/?issuerAddress=${issuerAddress}&title=${badgeTitle}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};

// @returns badge details for issuer single badge
export const getCertificantBadgeDetail = async (certificantAddress: string, badgeTitle: string) => {

    const response = await api.get(`/badge/get/certificant/single/?certificantAddress=${certificantAddress}&title=${badgeTitle}`);


    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Register Issuer')
};




